module.exports = __webpack_public_path__ + "static/Hammock-21f4ef43091783fbb282adefd8b5f5d6.jpg";